import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

// socket client
// Нужно для работы laravel echo
// см (src/common/composable/useSockets)
import { io } from 'socket.io-client'
//@ts-ignore
window.io = io

// styles
import 'mosha-vue-toastify/dist/style.css'
import '@/assets/scss/main.scss'

// tailwind
import '@/assets/css/tailwind.css'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)

app.mount('#app')
